import React from 'react';
import {
  MessagesLabel,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListMainHeader/components/MessagesLabel';
import { FDSecondaryActionIconButton, Stack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  useThreadSectionCollapseContext,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/ThreadCollapseContext';

const ThreadListMainHeader = () => {
  const isMobile = useMobileLayout();
  const { setCollapsed } = useThreadSectionCollapseContext();

  if (isMobile) {
    return null;
  }

  return (
    <Stack alignItems={'center'} justifyContent={'space-between'}>
      <MessagesLabel />
      <FDSecondaryActionIconButton icon={'chevronLeft'} onClick={() => setCollapsed(true)} />
    </Stack>
  );
};

ThreadListMainHeader.defaultProps = {
};

ThreadListMainHeader.propTypes = {
};

export { ThreadListMainHeader };
